import ConnexionPage from '@/components/ConnexionPage.vue';
import SignPage from '@/components/SignPage.vue';

import MasterPage from '@/components/MasterPage.vue';
import RegistrationPage from '@/components/RegistrationPage.vue';
import SupervisionPage from '@/components/SupervisionPage.vue';
import SigningUpCertificateCustomer from '@/components/MasterPage/Administration/SMAForm/SignupOptions/SigningUpCertificateCustomer.vue';

export const routes = [
    { path: '/V3/*', redirect: { name: 'route-name' }},
    /** Page de connexion DCX */
    { path: '/', component: ConnexionPage, name: 'Connexion' },
    /** Route de redirection pour l'expiration de session */ 
    { path: '/SignOut', component: SignPage, name: 'SignOut' },
    /** Route de redirection pour la fin de session OIDC (en cas de besoin administrateur) */
    { path: '/SignOutSSO', component: SignPage, name: 'SignOutOidc' },
    /** Portail de connexion OpenIdConnect (OIDC) à destination des clients supportant le Single Sign-On OIDC */
    { path: '/SignInSSO/:key', component: SignPage, name: 'SignInOidc' },
    /** Portail de connexion (SSO) pour les partenaires de Dcx */
    { path: '/SignInSSOPartner/:provider', component: SignPage, name: 'SignInPartner'},
    { path: '/Master', component: MasterPage, name: 'Master' }, 
    { path: '/Supervision', component: SupervisionPage, name: 'Supervision' },
    //{ path: '/HeritageManagement', component: HeritageManagementPage, name: 'HeritageManagement' }
    /** Page de validation d'un enregistrement d'utilisateur ou changement de mot de passe */
    { path: '/Registration/:validationToken', component: RegistrationPage, name: "Registration"},
    /** Page de signature d'un mandat */
    { path: '/Signature/:token', component: SigningUpCertificateCustomer, name: "Signature"}
]
